/**
 * @congress/platform-helpers v3.0.0
 * @version 3.0.0
 * @license CYIM: www.cyim.com
 */

class Configuration {
  static get EnvConfig() {
    return {
      VUE_APP_GRAPHQL_HTTP: "$VUE_APP_GRAPHQL_HTTP",
      VUE_APP_GRAPHQL_WS: "$VUE_APP_GRAPHQL_WS",
      VUE_APP_PROM_HTTP: "$VUE_APP_PROM_HTTP",
      VUE_APP_GTM_TAG: "$VUE_APP_GTM_TAG",
      VUE_APP_JITSI_HTTP: "$VUE_APP_JITSI_HTTP",
      VUE_APP_GATEWAY_API: "$VUE_APP_GATEWAY_API",
      VUE_APP_KEYCLOACK_URL: "$VUE_APP_KEYCLOACK_URL",
      VUE_APP_FIREBASE_OPTIONS: "$VUE_APP_FIREBASE_OPTIONS",
      VUE_APP_KUZZLE_URL: "$VUE_APP_KUZZLE_URL",
      VUE_APP_KUZZLE_PORT: "$VUE_APP_KUZZLE_PORT",
      VUE_APP_PROGRAM_CONFIG_URL: "$VUE_APP_PROGRAM_CONFIG_URL",
      VUE_APP_MOBILE_BACKOFFICE_URL: "$VUE_APP_MOBILE_BACKOFFICE_URL",
      VUE_APP_WEBHOOK_URL: "$VUE_APP_WEBHOOK_URL"
    };
  }
  static value(key) {
    // If the key does not exist in the EnvConfig object of the class, return null
    if (!Object.prototype.hasOwnProperty.call(this.EnvConfig, key)) {
      console.error(`Configuration: There is no key named "${key}". Please add it in Configuration class.`);
      return;
    }

    // Get the value
    const value = this.EnvConfig[key];

    // If the value is null, return
    if (!value) {
      console.error(`Configuration: Value for "${key}" is not defined`);
      return;
    }
    if (!value.startsWith("$VUE_APP_")) {
      // value was already replaced, it seems we are in production (containerized).
      return value;
    }

    // value was not replaced, it seems we are in development.
    const envName = value.substr(1); // Remove $ and get current value from process.env
    const envValue = process.env[envName];
    if (!envValue) {
      console.error(`Configuration: Environment variable "${envName}" is not defined`);
      return;
    }
    return envValue;
  }
}
export { Configuration as default };
//# sourceMappingURL=config.js.map
